export default {
	MAIN: 'main',
	NOTIFICATION_PREFERENCES: 'notification_preferences',
	HELP: 'help',
}
